export const configRegistry: Record<string, () => Promise<any>> = {
    Cars: () => import('@/components/listing/cars/cars.config'),
    Clients: () => import('@/components/modules/clients/clients.config'),
    Quotations: () => import('@/components/modules/quotations/quotations.config'),
    Sales: () => import('@/components/modules/sales/sales.config'),
    Opportunities: () => import('@/components/modules/opportunities/opportunities.config'),
    Activities: () => import('@/components/modules/activities/activities.config')
};
  